import * as React from 'react';
import { AskDataSettings } from './AskDataSettings';

export const DatasourceDialog = () => (
    <div className="tb-details">
        <table>
            <tbody>
                <tr>
                    <td className="tb-label">About</td>
                    <td className="tb-details-value"></td>
                    <td className="tb-details-button-cell"></td>
                </tr>
                <AskDataSettings />
            </tbody>
        </table>
    </div>
);